import layout from '@views/layout/index.vue';

const walkthroughRoutes = [
  {
    path: '/gp',
    name: 'nav',
    component: layout,
    children: [
      {
        path: 'square',
        name: 'square',
        redirect: 'recommend',
        meta: {
          pageType: 'square-attention',
          pageName: '动态广场推荐',
          keepAlive: true,
        },
      },
      {
        path: 'nearby',
        name: 'nearby',
        meta: {
          pageType: 'square-near',
          pageName: '动态广场附近',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "nearby" */ '@views/square/nearby/index.vue'),
      },
      {
        path: 'follow',
        name: 'follow',
        meta: {
          pageType: 'square-attention',
          pageName: '动态广场关注',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "follow" */ '@views/square/follow/index.vue'),
      },
      {
        path: 'recommend',
        name: 'recommend',
        meta: {
          pageType: 'square-recommend',
          pageName: '动态广场推荐',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "recommend" */ '@views/square/recommend/index.vue'),
      },
      {
        path: '/gp/square/particulars/:id',
        name: 'square-particulars',
        meta: {
          pageType: 'detailed',
          pageName: '动态详情',
          keepAlive: false,
          hideTopNav: true,
          hideRightNav: true,
        },
        component: () => import(/* webpackChunkName: "particulars" */ '@views/square/particulars/index.vue'),
      },
    ],
  },
];

function addMeta(walkthroughRoute) {
  walkthroughRoute.children.forEach((route) => {
    if (route.children) {
      addMeta(route);
      return;
    }
    route.meta.sideBar = 'square';
  });
}
addMeta(walkthroughRoutes[0]);

export default walkthroughRoutes;

